import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as ownership from '@webapp/sdk/ownership';
import { Action } from 'redux';
import { GetOwnershipsSuccess, GetOwnershipsError } from '../action-creators';
import { GetTracksSuccess } from '../../tracks/action-creators';
import { GET_TRACKS_SUCCESS } from '../../tracks/actions';


export const getOwnershipForTrackEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, GetTracksSuccess>(GET_TRACKS_SUCCESS),
    mergeMap(async (action) => {
      try {
        const ids = action.tracks
          .map((t) => t.id)
          .filter((i) => !!i)
          .join(',');

        const ownershipList = await ownership.list(ids);
        
        return new GetOwnershipsSuccess(ownershipList);
      } catch (err) {
        return new GetOwnershipsError(err.message)
      }
    })
  );